var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasStatus)?_c('Badge',{attrs:{"variant":_vm.variant,"text":_vm.$t('threats.status.' + _vm.status).toString()}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }